var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62105 6.33902e-07L8.17722 4.97857e-07C8.3708 4.80934e-07 8.55618 0.07692 8.69301 0.213747C9.36643 0.887166 12.6531 4.17418 13.6585 5.17927C13.9432 5.46396 13.9432 5.92552 13.6585 6.21021L8.69301 11.1757C8.55618 11.3126 8.3708 11.3895 8.17722 11.3892C7.86889 11.3892 7.19799 11.3892 6.62105 11.3895C6.32627 11.3895 6.06018 11.2117 5.94731 10.9393C5.83476 10.6669 5.89687 10.3532 6.10558 10.1448L10.486 5.76442C10.5244 5.72595 10.5244 5.66352 10.486 5.62506L6.10558 1.24469C5.89687 1.0363 5.83476 0.722596 5.94731 0.450201C6.06018 0.177807 6.32627 6.59673e-07 6.62105 6.33902e-07ZM0.729259 1.14898e-06L2.28544 1.01293e-06C2.4787 9.96038e-07 2.66439 0.0769205 2.80091 0.213748L7.76643 5.17927C8.05112 5.46396 8.05112 5.92552 7.76643 6.21021L2.80091 11.1757C2.66439 11.3126 2.4787 11.3895 2.28544 11.3892C1.97679 11.3892 1.30589 11.3892 0.72926 11.3895C0.434167 11.3895 0.168393 11.2117 0.0555262 10.9393C-0.0573409 10.6669 0.0050827 10.3532 0.213477 10.1448L4.59385 5.76442C4.63232 5.72595 4.63232 5.66352 4.59385 5.62506L0.213476 1.24469C0.00508189 1.0363 -0.0573418 0.722596 0.0555252 0.450201C0.168392 0.177807 0.434166 1.17478e-06 0.729259 1.14898e-06Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolid);
export default __webpack_public_path__ + "static/media/SOLID.36bc4d4b45473f89e41337ac6f0e7fb1.svg";
export { ForwardRef as ReactComponent };